/**
 * Pure decision used by <ScrollManager>: given navigation context, what should
 * the page scroll to?
 *  - `'hash'` → an in-page `#anchor` is present, defer to anchor scrolling.
 *  - a number → scroll to that Y offset (restoring a previous position on POP).
 *  - `0` → scroll to the top (forward navigation / no memory recorded).
 *
 * Kept dependency-free so it can be unit-tested without pulling in
 * react-router-dom (whose jest resolution is flaky in some dev setups).
 */
export function decideScrollTarget({ navType, saved, hasHash }) {
  if (hasHash) return 'hash';
  if (navType === 'POP' && typeof saved === 'number') return saved;
  return 0;
}
